export const healthcareSupport = {
  "cutaquig": {
    title: "COPAY ASSISTANCE",
    description: "If you need copay assistance for your patient please visit The Cutaquig Copay Assistance Portal For Providers by clicking the button below. Eligible patients can receive up to a maximum of $12,500 per calendar year of enrollment to cover the deductible, copay, and/or coinsurance for Cutaquig.",
    eligibilityCriteria: {
      title: "ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE",
      items: [
        { label: "The patient must be receiving treatment with Cutaquig or have a prescription to begin treatment." },
        { label: "The patient must receive treatment with an Octapharma Cutaquig National Drug Code (NDC)." },
        { label: "The patient must have commercial insurance." }
      ]
    },
    restrictions: {
      title: "RESTRICTIONS",
      items: [
        { label: "Those with Medicare, Medicaid, Medigap, VA, DOD, Tricare or other federal or state government health insurance are not eligible." },
        { label: "The Copay Assistance Program does not cover costs associated with administration of therapy, such as office visits, infusion costs, or other professional services." }
      ]
    }
  },
  "fibryga": {
    title: "COPAY ASSISTANCE",
    description: "If you need copay assistance for your patient please visit The Fibryga Copay Assistance Portal For Providers by clicking the button below. Eligible patients can receive up to a maximum of $2,500 per enrollment for copay assistance associated with the cost of Fibryga. Enrollment can be renewed at Octapharma's discretion up to 3 times within a calendar year.",
    eligibilityCriteria: {
      title: "ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE",
      items: [
        { label: "The patient must be receiving treatment with Fibryga or have a prescription to begin treatment." },
        { label: "Patient must have commercial insurance" },
        { label: "Patient must use Fibryga® for the FDA-approved indication of treatment of acute bleeding episodes in adults and children with congenital fibrinogen deficiency, including afibrinogenemia and hypofibrinogenemia, with a diagnosis code of D68.2" }
      ],
      note: "Note: Diagnosis codes are provided for reference only. Selection and documentation of an appropriate diagnosis code are the responsibility of the patient's health care provider."
    },
    restrictions: {
      title: "RESTRICTIONS",
      items: [
        { label: "Those with Medicare, Medicaid, Medigap, VA, DOD, Tricare or other federal or state government health insurance are not eligible." },
        { label: "The Copay Assistance Program does not cover costs associated with administration of therapy, such as office visits, infusion costs, or other professional services." }
      ]
    }
  },
  "nuwiq": {
    title: "COPAY ASSISTANCE",
    description: "If you need copay assistance for your patient please visit NUWIQ® Copay Assistance Portal For Providers by clicking the button below. Eligible patients can receive up to a maximum of $12,000 per calendar year of enrollment to cover the deductible, copay, and/or coinsurance for NUWIQ®.",
    eligibilityCriteria: {
      title: "ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE",
      items: [
        { label: "The patient must be receiving treatment with NUWIQ® or have a prescription to begin treatment." },
        { label: "The patient must have commercial insurance." }
      ]
    },
    restrictions: {
      title: "RESTRICTIONS",
      items: [
        { label: "Those with Medicare, Medicaid, Medigap, VA, DOD, Tricare or other federal or state government health insurance are not eligible." },
        { label: "The Copay Assistance Program does not cover costs associated with administration of therapy, such as office visits, infusion costs, or other professional services." }
      ]
    }
  },
  "octagam": {
    title: "COPAY ASSISTANCE",
    description: "If you need copay assistance for your patient please visit Octagam 5% or Octagam 10% Copay Assistance Portal For Providers by clicking the button below. Eligible patients can receive up to a maximum of $12,500 per calendar year of enrollment to cover the deductible, copay, and/or coinsurance for Octagam 5% or Octagam 10%.",
    eligibilityCriteria: {
      title: "ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE",
      items: [
        { label: "The patient must be receiving treatment with Octagam 5% or Octagam 10% or have a prescription to begin treatment." },
        { label: "The patient must receive treatment with an Octapharma Octagam 5% or Octagam 10% National Drug Code (NDC)" },
        { label: "The patient must have commercial insurance." }
      ]
    },
    restrictions: {
      title: "RESTRICTIONS",
      items: [
        { label: "Those with Medicare, Medicaid, Medigap, VA, DOD, Tricare or other federal or state government health insurance are not eligible." },
        { label: "The Copay Assistance Program does not cover costs associated with administration of therapy, such as office visits, infusion costs, or other professional services." }
      ]
    }
  },
  "panzyga": {title: "COPAY ASSISTANCE",
    description: "If you need copay assistance for your patient please visit The Panzyga Copay Assistance Portal For Providers by clicking the button below. Eligible patients can receive up to a maximum of $12,500 per calendar year of enrollment to cover the deductible, copay, and/or coinsurance for Panzyga.",
    eligibilityCriteria: {
      title: "ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE",
      items: [
        { label: "The patient must be receiving treatment with Panzyga® or have a prescription to begin treatment." },
        { label: "The patient must receive treatment with an Octapharma Panzyga® National Drug Code (NDC)" },
        { label: "The patient must have commercial insurance." }
      ]
    },
    restrictions: {
      title: "RESTRICTIONS",
      items: [
        { label: "Those with Medicare, Medicaid, Medigap, VA, DOD, Tricare or other federal or state government health insurance are not eligible." },
        { label: "The Copay Assistance Program does not cover costs associated with administration of therapy, such as office visits, infusion costs, or other professional services." }
      ]
    }
  },
  "wilate": {
    title: "COPAY ASSISTANCE",
    description: "If you need copay assistance for your patient please visit WILATE® Copay Assistance Portal For Providers by clicking the button below. Eligible patients can receive up to a maximum of $12,000 per calendar year of enrollment to cover the deductible, copay, and/or coinsurance for WILATE®.",
    eligibilityCriteria: {
      title: "ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE",
      items: [
        { label: "The patient must be receiving treatment with WILATE® or have a prescription to begin treatment." },
        { label: "The patient must have commercial insurance." }
      ]
    },
    restrictions: {
      title: "RESTRICTIONS",
      items: [
        { label: "Those with Medicare, Medicaid, Medigap, VA, DOD, Tricare or other federal or state government health insurance are not eligible." },
        { label: "The Copay Assistance Program does not cover costs associated with administration of therapy, such as office visits, infusion costs, or other professional services." }
      ]
    }
  },
};